import { useEffect } from "react";

const DEFAULT_TITLE = "Auswandern Florida | Gründung & Relocation auf Deutsch";
const DEFAULT_DESCRIPTION =
  "Persönliche Betreuung auf Deutsch für Deutsche & Schweizer in Florida: Unternehmensgründung, Visum & Green Card (E-2, EB-2 NIW, EB-1C), Relocation – und Begleitung nach der Auswanderung.";
const DEFAULT_KEYWORDS =
  "Auswandern Florida, Auswandern nach Florida, Unternehmensgründung Florida, E-2 Visum, E-2 Visum Voraussetzungen, EB-2 NIW, EB-1C, L-1A Visum, Green Card USA, Green Card durch Unternehmensgründung, Relocation Florida, Umzug nach Florida, Immigration Service Florida, Auswanderung USA, Auswandern mit Familie USA, LLC gründen Florida, Auswandern USA Deutsch, Beratung Auswanderung Florida, Unternehmensberatung Florida, Cleaning Service Florida gründen, Poolpflege Florida, Homewatch Florida, Auswandern Sarasota";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({
  title,
  description,
  keywords,
  jsonLd,
  type = "website",
}) {
  const fullTitle = title
    ? `${title} | Florida Business & Relocation`
    : DEFAULT_TITLE;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const metaKeywords = keywords || DEFAULT_KEYWORDS;
  const jsonLdText = jsonLd
    ? JSON.stringify(
        Array.isArray(jsonLd)
          ? { "@context": "https://schema.org", "@graph": jsonLd }
          : jsonLd,
      )
    : null;

  useEffect(() => {
    document.title = fullTitle;
    upsertMeta("name", "description", metaDescription);
    upsertMeta("name", "keywords", metaKeywords);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", metaDescription);
    upsertMeta("property", "og:type", type);
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", metaDescription);

    const canonicalUrl = `https://auswandernflorida.com${window.location.pathname}`;
    upsertLink("canonical", canonicalUrl);
    upsertMeta("property", "og:url", canonicalUrl);
    upsertMeta(
      "property",
      "og:image",
      "https://auswandernflorida.com/og-image.jpg",
    );
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta(
      "name",
      "twitter:image",
      "https://auswandernflorida.com/og-image.jpg",
    );

    if (jsonLdText) {
      // Statisches Homepage-Schema aus index.html ersetzen, damit pro Seite
      // nur das passende Schema im DOM steht.
      document.getElementById("static-jsonld")?.remove();
      let managed = document.getElementById("page-jsonld");
      if (!managed) {
        managed = document.createElement("script");
        managed.type = "application/ld+json";
        managed.id = "page-jsonld";
        document.head.appendChild(managed);
      }
      managed.textContent = jsonLdText;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullTitle, metaDescription, metaKeywords, type, jsonLdText]);

  return null;
}
